// packages
import { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

// Styles
import "./coach.css";

// Assets
import schoollogo from "../../assets/images/default_school.png";
import blankProfile from "../../assets/images/blank-profile.png";
import {
  getFromLocalStorage,
  setInToLocalStorage,
} from "../../utils/webStorage";

// Services
import userService from "../../services/user.service";

class SelectCoachDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coachId: null,
      coachName: "",
      coachProfilePic: "",
      schoolDetails: [],
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    var coachId = getFromLocalStorage("coachId");
    const adminRole = getFromLocalStorage("loginRole");
    this.setState({ coachId });
    if (adminRole === "COACH") {
      this.getCoachSchoolDetails(coachId);
    } else {
      this.getTeamAdminDetails(coachId);
    }
  }

  getCoachSchoolDetails(coachId) {
    userService
      .getCoachSchoolDetails(coachId)
      .then((response) => {
        const data = response.data.data;
        const coachName = data.coach.firstName;
        let coachProfilePic;
        let schoolSendLogo;
        if (data.coach.uploadedLogo != null) {
          coachProfilePic = data.coach.uploadedLogo.filePath;
          setInToLocalStorage("loginUserProfile", coachProfilePic);
        }
        const schoolDetails = data.schools;
        this.setState({ coachName, coachProfilePic, schoolDetails });
        if (schoolDetails.length < 2) {
          const schoolToSendId = schoolDetails[0].id;
          const schoolToSendName = schoolDetails[0].schoolName;
          if (schoolDetails[0].uploadedLogo != null) {
            schoolSendLogo = schoolDetails[0].uploadedLogo.filePath;
          }
          this.getSelectedSchoolId(
            schoolToSendId,
            schoolToSendName,
            schoolSendLogo
          );
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  getTeamAdminDetails(coachId) {
    userService
      .getTeamAdminSchoolDetails(coachId)
      .then((response) => {
        const data = response.data.data;
        const coachName = data.teamAdmin.firstName;
        let coachProfilePic;
        let schoolSendLogo;
        if (data.teamAdmin.uploadedLogo != null) {
          coachProfilePic = data.teamAdmin.uploadedLogo.filePath;
          setInToLocalStorage("loginUserProfile", coachProfilePic);
        }
        const schoolDetails = data.schools;
        this.setState({ coachName, coachProfilePic, schoolDetails });
        const schoolToSendId = schoolDetails[0].id;
        const schoolToSendName = schoolDetails[0].schoolName;
        if (schoolDetails[0].uploadedLogo != null) {
          schoolSendLogo = schoolDetails[0].uploadedLogo.filePath;
        }
        this.getSelectedSchoolId(
          schoolToSendId,
          schoolToSendName,
          schoolSendLogo
        );
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  getSelectedSchoolId(id, name, filepath) {
    const { history } = this.props;
    localStorage.setItem("schoolId", id);
    localStorage.setItem("schoolName", name);
    localStorage.setItem("schoolLogo", filepath);
    history.push("/schooladmindashboard");
  }

  render() {
    const { coachName, coachProfilePic, schoolDetails } = this.state;
    return (
      <section className="contact-section coach-dash-section">
        <div className="row">
          <div className="col-lg-4 col-sm-12 col-12 col-md-12 mx-auto">
            <div className="CoachDash-box">
              <div className="clear60"></div>
              {coachProfilePic && (
                <img
                  src={coachProfilePic}
                  alt="dashboard"
                  className="img img-responsive mb-2 coachImstyle"
                ></img>
              )}
              {!coachProfilePic && (
                <img
                  src={schoollogo}
                  alt="dashboard"
                  className="img img-responsive mb-2 coachImstyle"
                ></img>
              )}
              <p className="text-center fs-20 bold">{coachName}</p>
              <div className="clear10"></div>
              <p className="fs-20 regular">Choose your Dashboard</p>

              {schoolDetails &&
                schoolDetails.map((item, index) => (
                  <div key={item.id} className="dashboard-box mx-auto mt-3">
                    <div className="row">
                      <div className="col-lg-2 col-md-2 col-2 col-sm-2  pr-0">
                        <img
                          src={
                            item.uploadedLogo
                              ? item.uploadedLogo.filePath
                              : blankProfile
                          }
                          alt="dashboard"
                          className="img img-responsive h-100 w-100"
                          onClick={() => {
                            this.getSelectedSchoolId(
                              item.id,
                              item.schoolName,
                              item.uploadedLogo.filePath
                            );
                          }}
                        ></img>
                      </div>
                      <div className="col-lg-10 col-md-10 col-10 col-sm-10 text-left">
                        <Link
                          to="/schooladmindashboard"
                          className="black"
                          onClick={() => {
                            this.getSelectedSchoolId(
                              item.id,
                              item.schoolName,
                              item.uploadedLogo.filePath
                            );
                          }}
                        >
                          <label className="fs-20 ml-3 semi-bold mb-0 Dashboard-name cp">
                            {item.schoolName}
                          </label>
                        </Link>
                      </div>
                      <hr className="mt-0"></hr>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="clear20"></div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12 col-sm-12 text-center">
            <Link to="/login">
              <label className="fs-18 semi-bold red cp">Log Out</label>
            </Link>
            <div className="clear100"></div>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(SelectCoachDashboard);
